/** How long the post-declaration bid winner popup stays up before play begins. */
export const BID_REVEAL_DURATION_MS = 4000;
